/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Live_Caption_Chars_RemainingInputs */



/**
* | output |
* | --- |
* | "{count} characters remaining" |
*
* @param {Live_Caption_Chars_RemainingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_chars_remaining = /** @type {((inputs: Live_Caption_Chars_RemainingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Chars_RemainingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`${i?.count} caractères restants`)
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} verbleibende Zeichen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`${i?.count} caratteri rimanenti`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.count} символов осталось`)
	if (locale === "es") return /** @type {LocalizedString} */ (`${i?.count} caracteres restantes`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`剩余${i?.count}个字符`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`残り文字数 ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`शेष वर्ण ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`${i?.count} caracteres restantes`)
	return /** @type {LocalizedString} */ (`${i?.count} characters remaining`)
});